import * as helpers from '../helpers';

export default function initPreloader() {
    const preloader = document.getElementById('preloader');

    if (preloader !== null) {
        setTimeout(() => {
            helpers.addClass(preloader, '-is-hidden');
            preloader.setAttribute('aria-hidden', true);
        }, 500);
    }
}
